export default {
      id: "Icon--media-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--media",
      toString: function () {
        return this.url;
      }
    }